export default "__VITE_ASSET__4c534ae0__"